<mat-form-field appearance="fill" class="form-field-no-error">
  <mat-label>{{ 'performance.marketCapSelect.title' | translate }}</mat-label>
  <mat-select [ngModel]="summaryFlag()" (ngModelChange)="changeSummaryFlag.emit($event)">
    @for (option of summaryFlagList(); track option) {
      <mat-option [value]="option.value">
        {{ option.i18nTitle | translate }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
